import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../config/api';

export const fetchBanners = createAsyncThunk(
  'banner/fetchBanners',
  async (type = 'home', { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/api/public/banners?type=${type}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch banners');
    }
  }
);

const bannerSlice = createSlice({
  name: 'banner',
  initialState: {
    items: [],
    currentBanner: null,
    loading: false,
    error: null,
  },
  reducers: {
    setCurrentBanner: (state, action) => {
      state.currentBanner = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data || [];
        // Set the first banner (which should be hero type if available) as current banner
        if (state.items.length > 0) {
          // Prioritize hero type banners, then first active banner, then first banner
          const heroBanner = state.items.find(b => b.type === 'hero' && b.isActive !== false);
          const activeBanner = state.items.find(b => b.isActive !== false);
          state.currentBanner = heroBanner || activeBanner || state.items[0];
        } else {
          state.currentBanner = null;
        }
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentBanner } = bannerSlice.actions;
export default bannerSlice.reducer;

